import { Button } from '../../components/Button';
import { Input } from '../../components/Input';
import { Modal } from '../../components/Modal';
import styles from './SearchPage.module.css';

export type SaveFilterDialogProps = {
  readonly open: boolean;
  readonly name: string;
  readonly isShared: boolean;
  readonly isPending: boolean;
  readonly onNameChange: (name: string) => void;
  readonly onSharedChange: (isShared: boolean) => void;
  readonly onClose: () => void;
  readonly onSave: () => void;
};

/** Сохранение текущего JQL-запроса как фильтра (UC-SRC-04). */
export function SaveFilterDialog({
  open,
  name,
  isShared,
  isPending,
  onNameChange,
  onSharedChange,
  onClose,
  onSave,
}: SaveFilterDialogProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Сохранить фильтр"
      size="sm"
      footer={
        <>
          <Button variant="ghost" onClick={onClose}>
            Отмена
          </Button>
          <Button variant="primary" loading={isPending} disabled={name.trim().length === 0} onClick={onSave}>
            Сохранить
          </Button>
        </>
      }
    >
      <div className={styles['saveForm']}>
        <Input
          label="Название фильтра"
          value={name}
          onChange={(event) => onNameChange(event.target.value)}
        />
        <label className={styles['checkbox']}>
          <input type="checkbox" checked={isShared} onChange={(event) => onSharedChange(event.target.checked)} />
          Доступен команде проекта
        </label>
      </div>
    </Modal>
  );
}
